var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    title,
    overallPercent,
    rateChangeArrow,
    rateChange
  } = options;

__p+='\n<div class="loan-type">\n  <span>'+
((__t=( title ))==null?'':__t)+
'</span>\n</div>\n<span class="subtitle pos-relative">\n  '+
((__t=( overallPercent ))==null?'':__t)+
'\n  <i class="ra ra-arrow-'+
((__t=( rateChangeArrow ))==null?'':__t)+
'"/>\n</span>\n<span class="rate-change">\n  '+
((__t=( rateChange ))==null?'':__t)+
'\n</span>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_trends_title.jst.ejs